/** Hive sets this from the live /devices socket registry (not DB status). */
export function isDeviceSocketLive(device: { socketConnected?: boolean } | null | undefined): boolean {
  return device?.socketConnected === true;
}
